import * as types from './mutation-types'

export default {
  [types.CLEAR_ORDER] (state) {
    Object.assign(state, {
      bcv_id: null,
      coupons: [],
      discount_amount: {},
      discount_recommend: null,
      orderId: null,
      order_flags: null,
      payCountDown: -1,
      performs: [],
      pickupOrder: null,
      status: null,
      user: {},
      totalAmount: null,
      showLocation: true
    })
  },
  [types.ORDER_DETAIL] (state, result) {
    Object.assign(state, result)
  },
  [types.DELETE_PERFORM] (state, performs) {
    state.performs = performs
  },
  [types.SELECT_COUPON] (state, couponId) {
    state.discount_recommend = couponId
  },
  [types.UPDATE_USER] (state, user = {}) {
    console.log(user)
    state.user = user
  }
}



// WEBPACK FOOTER //
// ./src/store/order/mutations.js